import RXPMWPage from "components/pages/RXPMWPage";

export default function CaptureMabiCheckFreeMobilePayBills(props) {
    return <RXPMWPage page="pay-bills-contact-page" />
}